export default "__VITE_ASSET__DsP4dtdF__"